<template>
  <Modal :open.sync="open" :size="success ? 'small' : 'large'">
    <div
      class="dwp-text-green-500 dwp-p-14 dwp-text-center"
      data-cy="send-success"
      v-if="success"
    >Sent!</div>
    <div class="dwp-space-y-4" data-cy="send-report-modal" v-else v-loading="loading">
      <div class="dwp-flex dwp-items-center dwp-justify-center">
        <div
          class="sm:dwp-text-2xl dwp-text-xl dwp-leading-none dwp-text-gray-700 dwp-font-medium"
        >Email A Report</div>
      </div>

      <form class="dwp-space-y-4 dwp-mb-4" @submit.prevent="send">
        <TextInput
          ref="emailInput"
          type="email"
          label="To"
          data-cy="email"
          placeholder="Email Address"
          v-model="form.email"
          required
        />
        <TextInput
          ref="emailSubject"
          label="Subject"
          data-cy="subject"
          placeholder="Email Subject"
          v-model="form.subject"
          required
        />
        <div>
          <label
            for="text-input-69"
            class="dwp-block dwp-text-sm dwp-font-medium dwp-leading-5 dwp-text-gray-700 dwp-mb-1"
          >Message</label>
          <Editor
            ref="content"
            style="min-height: 75px"
            data-cy="message"
            class="dwp-block dwp-appearance-none dwp-bg-white dwp-rounded dwp-border dwp-p-3 focus:dwp-outline-none focus:dwp-shadow-outline dwp-w-full sm:dwp-text-sm sm:dwp-leading-5 dwp-shadow-none dwp-border-gray-300 dwp-text-gray-600 dwp-placeholder-gray-500 focus:dwp-border-gray-300 focus:sdwp-hadow-outline-gray dwp-leading-normal"
            placeholder="Write an optional message."
            :content.sync="form.message"
          />
        </div>
        <VButton type="primary" data-cy="send-email" buttonType="submit">Send</VButton>
        <div>
          <ListEmailPreview :list="list" class="dwp-mt-8" />
        </div>
      </form>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import TextInput from "@/components/ui/TextInput.vue";
import VButton from "@/components/ui/VButton.vue";
import Editor from "@/components/shared/Editor.vue";
import ListEmailPreview from "./ListEmailPreview.vue";
import { Firebase } from "@/services/firebase";
import { sync, get } from "vuex-pathify";

export default {
  components: {
    Modal,
    TextInput,
    ListEmailPreview,
    Editor,
    VButton,
  },

  data() {
    return {
      success: false,
      loading: false,
      form: {
        email: "",
        subject: "",
        message: "",
      },
    };
  },

  computed: {
    open: sync("ui/modal@email.report.open"),
    list: sync("ui/modal@email.report.list"),
    team: get("user/user@team"),
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.emailInput.focus();
    });
  },

  methods: {
    async send() {
      this.loading = true;
      if (process.env.NODE_ENV === "development") {
        Firebase.functions().useFunctionsEmulator("http://localhost:5001");
      }
      let sendReport = Firebase.functions().httpsCallable("lists-sendReport");
      try {
        await sendReport({
          to: this.form.email,
          subject: this.form.subject,
          message: this.form.message,
          team_id: this.team,
          list_id: this.list.id,
        });
        this.success = true;
        setTimeout(() => {
          this.loading = false;
          this.open = false;
        }, 1500);
      } catch (e) {
        if (e?.message) {
          alert(e.message);
        } else {
          alert("Something went wrong. Please contact support@docketwp.com.");
        }
        this.loading = false;
        return;
      }
    },
  },
};
</script>